export default __webpack_public_path__ + "static/media/et-sw.ec629a9a.svg";